import React from 'react'

const BlacklistIcon = (props) => {
  const { size, color } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={size} height={size}>
      <defs />
      <g stroke="null">
        <path
          fill={color}
          d="M180.536 286.355c-42.389 8.007-78.764 33.08-97.685 67.472-13.494 24.678-15.401 37.411-15.401 107.902v52.77l14.374 3.938c41.509 11.42 78.324 18.246 124.967 23.365 25.374 2.626 90.791 3.02 113.672.525 47.376-4.988 85.658-13.389 114.113-24.94l9.974-4.07-.587-62.615c-.586-67.34-.44-66.159-8.8-86.505-12.908-31.373-47.376-61.565-83.018-72.854-22.734-7.22-30.068-7.745-96.805-7.613-55.003 0-62.337.262-74.804 2.625zM237.53 4.63c-46.932 7.1-83.504 30.8-106.504 68.8-25.486 42.1-24.968 98.4 1.243 140 22.897 36.4 59.987 60.4 102.568 66.5 10.464 1.5 33.153 1.5 42.581 0 47.554-7.7 86.406-35 107.437-75.5 21.032-40.4 19.685-91.1-3.419-130-21.964-37-59.675-62.4-102.36-69.1-8.081-1.3-34.915-1.7-41.545-.7zm43.514 45.1c28.699 8.3 49.523 24.4 62.68 48.5 14.609 26.8 15.23 57.2 1.658 85.3-2.175 4.5-4.455 8.4-4.973 8.7-.518.3-31.599-29-69.103-65.2l-68.068-65.7 6.009-3.1c7.77-4.1 16.577-7.2 26.212-9.4 10.567-2.5 35.64-2 45.585.9zm-41.13 108l68.275 65.9-5.595 3c-7.874 4.2-18.545 7.9-28.802 9.9-11.604 2.2-32.324 1.5-43.41-1.6-26.419-7.3-48.59-24.3-61.644-47.1-15.644-27.6-15.748-62.6-.31-90.2 1.864-3.1 3.314-5.7 3.314-5.7l68.172 65.8z"
        />
      </g>
    </svg>
  )
}

BlacklistIcon.defaultProps = {
  size: 30,
  color: '#555555',
}

export default BlacklistIcon
